import assignedTypes from './assignedTypes'

export const getAssigned = payload => ({
  type: assignedTypes.GET_ASSIGNED,
  payload
})

export const getAssigendSuccess = payload => ({
  type: assignedTypes.GET_ASSIGNED_SUCCESS,
  payload
})

export const getAssigendFailure = payload => ({
  type: assignedTypes.GET_ASSIGNED_FAILURE,
  payload
})

export const clearAssigend = () => ({
  type: assignedTypes.CLEAR_ASSIGNED
})

export const setFilters = payload => ({
  type: assignedTypes.SET_FILTERS,
  payload
})

export const searchByMovementNumber = payload => ({
  type: assignedTypes.SEARCH_BY_MOVEMENT_NUMBER,
  payload
})

export const loadMore = payload => ({
  type: assignedTypes.LOAD_MORE,
  payload
})

export const putAssigned = (payload, callback) => ({
  type: assignedTypes.PUT_ASSIGNED_ORDER,
  payload,
  callback
})

export const putAssignedSuccess = payload => ({
  type: assignedTypes.PUT_ASSIGNED_ORDER_SUCCESS,
  payload
})

export const putAssignedFailre = payload => ({
  type: assignedTypes.PUT_ASSIGNED_ORDER_FAILURE,
  payload
})
